import React from "react";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import { ConfirmButton, CancelButton } from "components/Buttons";
import BaseDialog, { severityIcons } from "./BaseDialog";

function ConfirmDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  loading,
  severity,
  children,
}) {
  return (
    <BaseDialog
      open={open}
      onClose={onCancel}
      idPrefix="confirm-dialog"
      icon={severityIcons[severity] || severityIcons.question}
      title={title}
      message={message}
      actions={
        <>
          <CancelButton onClick={onCancel} disabled={loading}>
            {cancelText}
          </CancelButton>
          <ConfirmButton
            onClick={onConfirm}
            loading={loading}
            autoFocus
            startIcon={<Icon aria-hidden="true">check</Icon>}
          >
            {confirmText}
          </ConfirmButton>
        </>
      }
    >
      {children}
    </BaseDialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool,
  severity: PropTypes.oneOf(["info", "success", "warning", "error", "question"]),
  children: PropTypes.node,
};

ConfirmDialog.defaultProps = {
  confirmText: "Onayla",
  cancelText: "İptal",
  loading: false,
  severity: "question",
  children: null,
};

export default ConfirmDialog;
